import React from "react";
import AephoriaTable from '../comps/aephoriaTable';
import * as aserver from '../../APIClient';
import Modal from '../comps/modal';
import Button from '@material-ui/core/Button';
import { withRouter } from "react-router";
import { withStyles } from '@material-ui/core/styles';
import Toast from "../comps/alertMessage";
import LoadingBackdrop from '../comps/loadingBackdrop';
import AlertModal from "../comps/alertModal";
import * as utils from "../../Utilities";
// import { getTeamReportDownloadLinks } from "../../Utilities";
import deleteIcon from '../images/Trash.png'
import deleteIconBlue from '../images/Trash-blue.png'
import blueCopyIcon from '../images/Duplicate-blue.png'
import sendReportIcon from '../images/Paper airplane.png'
import printIcon from '../images/print.png'
import editIcon from '../images/Pencil.png'
import viewIcon from '../images/Search circle.png'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { isWindows } from "react-device-detect";
import pdf from '../images/pdf.png'
import html from '../images/html.png'



const drawerWidth = 240;
const cClipboardPasteMessage = "We've copied the text with the link to your clipboard. Please paste it here.";

const styles = theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
});

 class Couples extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
          coachId: localStorage.getItem('Id'),
          allCouplesData: [],
          previewModal:false,
          sendReportModal:false,
          impersonator: localStorage.getItem("impersonator"),
          disableGmail:false,
          failModalText:"",
          couplesUUID:[],
          previewExplanation: '',
          selected: 0,
          listOfReportsReady:[],
          openAlertModal:false,
          alertModalTitle:"",
          alertMessage:"",
          coachEmailAddress: localStorage.getItem("coachEmailAddress"),
          impersonator: localStorage.getItem("impersonator"),
          confirmationModal: false,
          confirmationHeading: "Email Ready",
          confirmationFunction: this.confirmationFunction,
          mailToAddress: "address",
          mailToSubject: "",
          mailToBody: "",
          editPronounsModal: false,
          editCoupleUUID: null,
          editPerson1Pronouns: "",
          editPerson2Pronouns: "",
          editPerson1Name: "",
          editPerson2Name: "",
          selectedCoupleUUIDs: [],
          secondaryCoachEmailAddress: "",
          invalidEmailAddress: true,
          showInvalidEmailAddressText: false,
          assignSCOModalOpen: false,
          revokeSCOModal: false,
          revokeSCOModalTitle: "",
          revokeMessage: "",
          revokeModalSubmitFunction: () => {},
          scoGivenToExist: false,
          scoReceivedFromExist: false,
          };
      }

      showHTMLReport = (url) => {
        window.open(url, '_blank')
      }

      showPrintingGuidelines = () =>{
        this.openAlertModal("Printing Guidelines",<>
          <p><b>Note:</b> the HTML pair reports (Couples and Workplace) are designed and optimized for viewing on your device (mobile, tablet, laptop etc), <b>but not for printing out.</b></p>
          <p>However, if you do want to print out the report, which we do not currently recommend, here are a couple of tips for the settings in your browser or system print options dialog:</p>
          <ul>
            <li>switch on "Background graphics", otherwise various bullet points and other graphics and charts may go missing.</li>
            <li>set Scale to 100.</li>
          </ul>
        </>);
      }

      downloadPDF = async (reportURL) => {
        this.setState({ openBackdrop: true });
        this.toastMessage("Downloading... ", "success");

        let pdfUrl = `${reportURL}?pdf=1`;
        let response = await fetch(pdfUrl);

        if (response.ok) {
              let blob = await response.blob();

              let filename = "report.pdf";
              const disposition = response.headers.get("Content-Disposition");
              if (disposition && disposition.includes("filename=")) {
                const matches = disposition.match(/filename="?(.+?)"?$/);
                if (matches && matches[1]) {
                  filename = matches[1];
                }
              }

              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              link.remove();
              this.setState({ openBackdrop: false });
            } else {
              this.toastMessage("Download failed", "danger");
            }
       
      };

      openSendReportModal =(uuids)=>{
        if (!this.allReportsSupplied(uuids)) {
          this.openAlertModal("Please note","Some selected reports have not yet been provided. Please deselect them before proceeding. You can only send reports that are available.");
          return;
        }

        if (uuids.length > 1) {
            this.setState({
              disableGmail: true
            })
        }
        this.setState({
          sendReportModal:true,
          couplesUUID:uuids
        })
      }

      openEditPronounsModal = (selected) => {
        const couple = this.state.allCouplesData.find(({ uuid }) => uuid === selected[0]);
        if (!couple)
          return;
        this.setState({
          editPronounsModal: true,
          editCoupleUUID: couple.uuid,
          editPerson1Pronouns: couple.guest1Pronouns || "",
          editPerson2Pronouns: couple.guest2Pronouns || "",
          editPerson1Name: `${couple.assessments[0]?.clientName || ""} ${couple.assessments[0]?.clientSurname || ""}`.trim(),
          editPerson2Name: `${couple.assessments[1]?.clientName || ""} ${couple.assessments[1]?.clientSurname || ""}`.trim(),
        })
      }

      saveEditedPronouns = async () => {
        const { editCoupleUUID, editPerson1Pronouns, editPerson2Pronouns } = this.state;
        if (!editPerson1Pronouns || !editPerson2Pronouns) {
          this.toastMessage("Please specify pronouns.", "danger")
          return;
        }
        let updated = await aserver.put(`api/v2/couples/${editCoupleUUID}/pronouns`, {
          pronouns: [editPerson1Pronouns, editPerson2Pronouns],
        });
        if (updated.status === 200) {
          this.closeModal()
          this.toastMessage("Pronouns updated", "success")
          this.refreshTable()
        } else {
          this.openAlertModal("Please note", updated.data.error)
        }
      }

      hasRecordFromAnotherCoachCheck = (uuids)=>{
        for (let UUID of uuids) {
          let client = this.state.allCouplesData.find(({ uuid }) => uuid === UUID);
          if (client && client.scoReceivedFrom) {
            this.openAlertModal("Please Note", "Your selection includes pairs that were given to you by another coach. Please amend your selection and try again.")
            return true;
          }
        }
        return false;
      }

      openWrapUpModal = (uuids) => {
        let hasWrapped = false;
        let hasUnwrapped = false;

        for (let uuid of uuids) {
          let checkedIfWrapped = this.state.allCouplesData.find(({ uuid: recordUuid }) => recordUuid === uuid);
          if (checkedIfWrapped.coachWrappedUp) {
            hasWrapped = true;
          } else {
            hasUnwrapped = true;
          }
        }

        if (hasWrapped && hasUnwrapped) {
          this.openAlertModal("Warning", "The selection contains both previously wrapped up and unwrapped up pairs. Please change the selection to include only all wrapped up or all unwrapped up pairs.");
          return;
        }

        const confirmationMessage = hasUnwrapped ?
          "The selected pair(s) will be marked as wrapped up, which means they will be greyed out." :
          "The selected pair(s) will no longer be marked as wrapped up, which means they will no longer be greyed out.";

        this.setState({
          confirmationModal: true,
          confirmationModalText: confirmationMessage,
          confirmationHeading: "Confirmation",
          confirmationFunction: () => this.wrapUpAssessment(uuids),
        });
      }

      wrapUpAssessment = async (uuids) => {
        if (this.hasRecordFromAnotherCoachCheck(uuids))
          return;
        const { allCouplesData } = this.state;
        let failureMessages = [];
        let successCount = 0;
        for (let uuid of uuids) {
          let checkedIfWrapped = allCouplesData.find(({ uuid: recordUuid }) => recordUuid === uuid);
          let wrap = await aserver.put(`api/v2/couples/${uuid}`, {
            coachWrappedUp: checkedIfWrapped.coachWrappedUp === 1 ? false : true
          });
          if (wrap.status !== 200) {
            failureMessages.push(`${checkedIfWrapped.info.replace(/\n/g, " & ")} wrap up failed.`);
          } else {
            successCount++;
          }
        }
        if (failureMessages.length > 0) {
          this.openAlertModal("Failed", failureMessages.join(' '));
        }
        if (successCount > 0) {
          this.refreshTable()
        }
      }

      sendReport = async (serverSend) => {
        this.setState({
          sendReportModal:false,
          previewModal:false,
        })
        const {couplesUUID, coachEmailAddress, impersonator } = this.state;
        if (serverSend) {
          this.toastMessage("Sending email...", "success")
        } else {
          this.toastMessage("Generating email...", "success")
        }
        let data = {
          destinationEmailAddress: impersonator ==="false" ? null : coachEmailAddress,          
        } 
        for (let UUID of couplesUUID){

          let sendReport = (await aserver.post(`api/v2/couples/${UUID}/sendReport?serverSend=${serverSend}`, data)).data;
            if (!serverSend) {
              this.setState({
                showToast: false,
                openBackdrop: false
              });
              this.alertUserToEmailReady(`The report email has been generated.`, sendReport.emailAddress, sendReport.subject, sendReport.body);
            }else{
              if(sendReport.sent === true){
                this.refreshTable()
              }else{
                this.openAlertModal("Failed","Unexpected error sending reports - please try again later.")
              }
            }

          }
      }

      openPreviewModal = async() => {
          const {couplesUUID, allCouplesData } = this.state;
          this.setState({
            sendReportModal: false,
            previewModal: true,
          });
          let data = {
            destinationEmailAddress: null // if not null, will be used instead of couple's email addresses - use to send to Coach when impersonating as per assessment send reports
          }
          var previewTextArray = [];
          var failureMessages = [];
          var previewCounts = {
            reports: 0,
          }
          for (let UUID of couplesUUID) {
            // get client that we're sending this email for:
            var couple = allCouplesData.find(({ uuid }) => uuid === UUID)
            // get type of email we're sending for this client
            var typeOfEmail = 'reports'; // assume type is reports
              previewCounts[typeOfEmail] = previewCounts[typeOfEmail] + 1;
              if (previewCounts[typeOfEmail] > 1) {
                // we already have a preview of this kind of email, so continue to the next email
                continue;
              }
            let sendAPIForPreview = (await aserver.post(`api/v2/couples/${couple.uuid}/sendReport?forPreview=true`, {})).data
            if (sendAPIForPreview.status === 400) {
              failureMessages.push(sendAPIForPreview.data.error.info)
              continue;
            }
            var heading = `Send Reports for ${couple.info.replace(/\n/g, " & ")}`
              
            var previewText = sendAPIForPreview.body.replace(/(\r\n|\n|\r)/g, "<br />");
            previewTextArray.push(`<b>${heading}</b> <br><br> ${previewText}`);
          }
      
          // set preview explanation
          var explanation;
          var check = 'Please check to ensure the text is correct regarding couple names and other details. ';          
          if (couplesUUID.length === 1) {
            // 1) one email with one preview
            explanation = 'The email is previewed below. ' +
              check +
              'Once you approve the preview, the email will be sent';
          } else {
            // 2) more than one email
            if (previewTextArray.length === couplesUUID.length) {
              //2.1) with as many emails as there are previews
              explanation = 'The emails are previewed below. ' +
                check + 
                'Once you approve the preview, the emails will be sent';
            } else {
              //2.2) with more emails than previews
              // (either with one preview or more than one)
              explanation = (previewTextArray.length === 1 ? 'A selected email is previewed below. ' : 'A selection of emails are previewed below. ') +
                check +
                'Note, this is just a representative selection of the emails to be sent. Names and links in the other emails are automatically updated. ' +
                'Once you approve the preview, the emails for all the clients will be sent';
            }
          }
          this.setState({ previewExplanation: explanation });
      
          document.getElementById("previewTextArea").innerHTML += previewTextArray.join('<br><br><br>');
      
          if (failureMessages.length > 0) {
            this.setState({
              failModalText: failureMessages,
            })
            this.openAlertModal("Failed")
          }
        }

        allReportsSupplied = (selectedUUIDs) => {
          let allSupplied = true;
          for (let UUID of selectedUUIDs) {
            const result = this.state.allCouplesData.find(({ uuid }) => uuid === UUID);
            if (result.reportSuppliedAt == "-") {
              allSupplied = false;
              break;
            }
          }
          return(allSupplied)
        }

      checkForSuppliedReports = (sendServer) => {
        this.setState({
          sendReportModal:false
        })
        const listOfReportsReady = [];
        let allSupplied = true;

        for (let UUID of this.state.couplesUUID) {
          const result = this.state.allCouplesData.find(({ uuid }) => uuid === UUID);

          if (result.reportSuppliedAt !== "-") {
            listOfReportsReady.push(result.info + " supplied on: " + result.reportSuppliedAt);
          } else {
            allSupplied = false;
          }
        }

        this.setState({ listOfReportsReady });

        if (allSupplied) {
          if(sendServer) 
           this.openPreviewModal();
          else
            this.sendReport(false)
        } else {

           this.openAlertModal("Please note","Some selected reports have not been supplied. Please deselect them before proceeding.");
        }
      };

      alertUserToEmailReady = (message, address, subject, body) => {
        let textBody = <div>{message} <br></br>The body text will be copied to your clipboard.
          Click ok to open the email in your email client, and then paste the body text into that email.
          <br></br>
          <br></br>
          <b>Note:</b> this will only work if your operating system / browser has been configured to open <tt>mailto:</tt> links correctly.
          </div>
          
        this.setState({
          confirmationModal: true,
          confirmationModalText: textBody,
          confirmationHeading: "Email Ready",
          confirmationFunction: (e) => this.confirmation(e),
          mailToAddress: address,
          mailToSubject: subject,
          mailToBody: body,
        })
      }

      
      confirmation = async (confirmationBoolean) => {
        const { mailToAddress, mailToSubject, mailToBody } = this.state
        if (confirmationBoolean) {
          await this.copyTextToClipboard(mailToBody,true);
          window.open(`mailto:${mailToAddress}?subject=${mailToSubject}&body=${encodeURIComponent(cClipboardPasteMessage)}`);
        }
        this.setState({
          confirmationModal: false,
        })
      }

      copyTextToClipboard = async(text,clipboardCancel) => {
        await navigator.clipboard.writeText(text)
        if(!clipboardCancel)
          this.setState({clipboardModal:true})
        else
          this.toastMessage("Copied to clipboard", "success")
      }

      massageData = (couples) => {
        this.setState({
          allCouplesData:couples
        })

        let scoReceivedFromExists = false;
        let scoGivenToExists = false;

        for (let record of couples) {
          record.SCOReceived = record.scoReceivedFrom && record.scoReceivedFrom.name
            ? `${record.scoReceivedFrom.name} ${record.scoReceivedFrom.surname}`
            : '';
          if (record.SCOReceived)
            scoReceivedFromExists = true;

          record.SCOGiven = record.scoGivenTo && record.scoGivenTo.length
            ? (
                <span style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {record.scoGivenTo.map((coach, index) => (
                    <span key={index} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      {`${coach.name} ${coach.surname}`}
                      <img
                        src={deleteIconBlue}
                        style={{ cursor: 'pointer', width: "18px" }}
                        onClick={() => this.openRevokeModal(record, coach)}
                        alt="Revoke"
                      />
                    </span>
                  ))}
                </span>
              )
            : '';
          if (record.scoGivenTo && record.scoGivenTo.length)
            scoGivenToExists = true;
        }

        this.setState({
          scoGivenToExist: scoGivenToExists,
          scoReceivedFromExist: scoReceivedFromExists
        });

        for (let record of couples) {
          let showHTMLReport = (record.coupleType=='Romance')||(record.coupleType=='Colleagues')||(record.coupleType=='Professionalxxx');

          aserver.convertUTCToLocal(record, 'reportSent');
          aserver.convertUTCToLocal(record, 'reportSuppliedAt');
          aserver.convertUTCToLocal(record, 'createdAt');

          let couples = [record.assessments[0], record.assessments[1]];
        
          const a1 = `${record.assessments[0]?.clientName || ""} ${record.assessments[0]?.clientSurname || "\u200B"}`;
          const a2 = `${record.assessments[1]?.clientName || ""} ${record.assessments[1]?.clientSurname || "\u200B"}`;
          record.info = `${a1}\n${a2}`;

          const company1 = record.assessments[0]?.clientCompany || "\u200B";
          const company2 = record.assessments[1]?.clientCompany || "\u200B";
          record.company = `${company1}\n${company2}`;

          const project1 = record.assessments[0]?.userCoach || "\u200B";
          const project2 = record.assessments[1]?.userCoach || "\u200B";
          record.project = `${project1}\n${project2}`;

          record.enneaResults = couples.map(g => {
            if (!g.userEnnea || !g.userTriType || !g.userInstinct || !g.userBlindInstinct) {
              return "-";
            }
            return `${g.userEnnea} ${g.userTriType} ${g.userInstinct} b${g.userBlindInstinct}`;
          }).join('\n');

          const imf1 = `${record.assessments[0]?.scoreIMF || "\u200B"}`;
          const imf2 = `${record.assessments[1]?.scoreIMF || "\u200B"}`;
          record.maturityResults = `${imf1}\n${imf2}`;

          record.reportURL = `${aserver.getServerRoot()}/publish/reports/pair/${record.uuid}`;
          record.reportOverviewURL = `${aserver.getServerRoot()}/publish/reports/pairoverview/${record.uuid}`;
          record.reportLink=(record.reportSuppliedAt!='-')?
            <>{showHTMLReport&&<img src={html} onClick={(event) => { event.stopPropagation();this.showHTMLReport(record.reportURL);}} className="teamReportDownloadImage" alt='icon' style={{ "cursor": "pointer" }}/>}
            <img 
              src={pdf}
              onClick={(event) => {
                event.stopPropagation();
                this.downloadPDF(record.reportURL)
              }} 
              style={{ "cursor": "pointer" }}
              className="teamReportDownloadImage"
              alt="pdf icon"
            />
          </>:<>Not available yet</>
          record.reportLinkOverview=(record.reportSuppliedAt!='-')?
            <>
            <img 
              src={pdf}
              onClick={(event) => {
                event.stopPropagation();
                this.downloadPDF(record.reportOverviewURL)
              }} 
              style={{ "cursor": "pointer" }}
              className="teamReportDownloadImage"
              alt="pdf icon"
            />
          </>:<>Not available yet</>
  
        }

      }

      showToast = () => {
        this.setState(
          {
            showToast: true
          },
          () => {
            setTimeout(() => this.setState({ showToast: false }), 2000);
          }
        );
      }

      refreshTable=()=>{
        window.location.reload(false)
        this.closeModal()
      }

      selectedData =(numberOfRecordsSelected)=>{
       this.setState({
         displayedNumberOfRecordsSelected: numberOfRecordsSelected,
       })
      }

      toastMessage = (text, level) =>{
        this.setState({
          message:text,
          level: level
        })
        this.showToast()
      }

      openAlertModal=(title, message)=>{
        this.closeModal()
        this.setState({
          alertModalTitle: title,
          alertMessage: message,
          openAlertModal: true,
        })
      }

      closeModal = () => {
        this.setState({
          modalIsOpen: false,
          openModal:false,
          openAlertModal: false,
          confirmationModal: false,
          duplicateModal:false,
          assignSCOModalOpen:false,
          revokeSCOModal:false,
          previewModal:false,
          listOfReportsReady:[],
          sendReportModal:false,
          editPronounsModal:false,
        });
      }

      copyTextToClipboard = async(text) => {
        await navigator.clipboard.writeText(text)
        this.toastMessage("Copied to clipboard", "success")
      }

      escFunction =(event)=>{
        if(event.keyCode === 27) {
         this.closeModal()
        }
      }

        selectedData = (data) => {
          this.setState({
            selected: data
          })
          if (data > 1) {
            this.setState({
              disableGmail: true
            })
          } else {
            this.setState({
              disableGmail: false
            })
          }
        }

      componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
        if(localStorage.getItem("ReRoute")){
          this.handleAdd();
          localStorage.removeItem("ReRoute")
        }
        if(localStorage.getItem("hasMaturityAccreditation")!=="1"){
          this.setState({
            reportType:"Ennea"
          })
        }
      }

      componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
      }

      handleChange = ({ target: { name, value, type } }) => {
        let invalidEmailAddress = this.state.invalidEmailAddress;
        if (type === "email") {
          invalidEmailAddress = !utils.validateEmail(value);
        }

        this.setState({
          [name]: value,
          invalidEmailAddress,
          showInvalidEmailAddressText: type === "email" ? invalidEmailAddress : this.state.showInvalidEmailAddressText,
        });
      }

      openAssignSCOModal = (selectedCoupleUUIDs) => {
        const receivedSelected = selectedCoupleUUIDs.some(uuid => {
          const record = this.state.allCouplesData.find(r => r.uuid === uuid);
          return record && record.scoReceivedFrom;
        });
        if (receivedSelected) {
          this.openAlertModal("Please note", "You cannot assign SCO on a pair that was shared with you by another coach.");
          return;
        }
        this.setState({
          assignSCOModalOpen: true,
          selectedCoupleUUIDs: selectedCoupleUUIDs,
          secondaryCoachEmailAddress: "",
          invalidEmailAddress: true,
          showInvalidEmailAddressText: false,
        });
      }

      assignCoupleSCO = async () => {
        this.setState({ assignSCOModalOpen: false });
        let scoResult = await aserver.post(`api/v2/coaches/${this.state.coachId}/assignCoupleSCO`, {
          secondaryCoachEmailAddress: this.state.secondaryCoachEmailAddress,
          coupleUUIDs: this.state.selectedCoupleUUIDs
        });
        if (scoResult.data.success) {
          this.toastMessage("Success", "success");
          this.refreshTable();
        } else {
          this.openAlertModal("Please Note", scoResult.data.error || "That email address is not associated with a coach registered on the Aephoria system");
        }
      }

      openRevokeModal = (record, coach) => {
        this.setState({
          revokeSCOModalTitle: 'Revoke SCO',
          revokeModalSubmitFunction: () => this.revokeCoupleSCO(record, coach),
          revokeSCOModal: true,
          revokeMessage: `Take back this pair from coach ${coach.name + " " + coach.surname}?`,
        });
      }

      revokeCoupleSCO = async (record, coach) => {
        const records = [{ uuid: record.uuid, coachUUID: coach.uuid }];
        let scoResult = await aserver.post(`api/v2/coaches/${this.state.coachId}/revokeCoupleSCO`, {
          records: records
        });
        if (scoResult.data.success) {
          this.refreshTable();
        } else {
          this.openAlertModal("Failed", `SCO revoking failed: ${scoResult.data.error}`);
        }
      }



     render(){
        const classes = this.props.classes;
        const pronounOptions = this.props.pronounSets ? (
          <>
            <option hidden value="">Choose pronouns...</option>
            {Object.entries(this.props.pronounSets).map(([key, data]) => (
              <option key={key} value={key}>
                {data.forms.join(' / ')}
              </option>
            ))}
          </>
        ) : <></>;
        let showAllColumnsDesktop = [
          {dataField: "info", caption: "Info"},
          {dataField: "coupleType", caption: "Type"},
          {dataField: "reportLink", caption: "Report"},
          {dataField: "reportLinkOverview", caption: <>Coach<br></br>Companion</>},
          {dataField: "reportSent", caption: "Sent"},
          {dataField: "company", caption: "Company "},
          {dataField: "project", caption: "Project"},
          {dataField: "enneaResults", caption: "Enneagram Results"},
          {dataField: "maturityResults", caption: "Maturity Results"},
          {dataField: "createdAt", caption: "Created"},
        ];

        let SCOGiven = {dataField: "SCOGiven", caption: "Given To"};
        let SCOReceived = {dataField: "SCOReceived", caption: "Received From"};

        return (
          <main className="app-content">
                  <AephoriaTable
                  key={this.state.key}
                  // ====new endpoint needed ====//
                  route={`api/v2/coaches/${this.state.coachId}/couples`}
                  massageData = {this.massageData}
                  selectedData ={this.selectedData}
                  onDelete={() => window.location.reload()}
                  onSelectionChanged={this.onSelectionChanged}
                  filterButtons={utils.filterButtons.filter(button => ['allRecords', 'wrapped', 'unwrapped'].includes(button.id))}
                  // ====new endpoint needed ====//
                  deleteConfig={
                    {
                      endpoint: 'api/v2/couples',
                      pluralDisplayName: "Couples",
                      displayCallback: function(record) {
                        return(record.info.replace(/\n/g, " & "))
                      },
                      disabledDeleteCheck: (record) => record.reportSuppliedAt && record.reportSuppliedAt !== '-'
                    }
                  }
                  tableFunctions={[
                    { caption: 'Send Reports',
                        icon: sendReportIcon,
                        minRecordsRequired: 1,
                        ourownonclick: this.openSendReportModal,
                        frequentlyUsed: true,
                        mainMobileButton:false
                    },
                    { caption: 'Edit Pronouns',
                        icon: editIcon,
                        minRecordsRequired: 1,
                        maxRecordsRequired: 1,
                        ourownonclick: this.openEditPronounsModal,
                        frequentlyUsed: true,
                        mainMobileButton:false
                    },
                    { caption: 'Report Printing Guidelines',
                      icon: printIcon,
                      minRecordsRequired: 0,
                      ourownonclick: this.showPrintingGuidelines,
                      frequentlyUsed: true,
                      mainMobileButton:false
                  },
                    { caption: 'Assign SCO',
                      icon: viewIcon,
                      minRecordsRequired: 1,
                      ourownonclick: this.openAssignSCOModal,
                      frequentlyUsed: false,
                      mainMobileButton: false
                  },
                    { caption: 'Wrap/Unwrap',
                      icon: <AssignmentTurnedInIcon />,
                      minRecordsRequired: 1,
                      ourownonclick: this.openWrapUpModal,
                      frequentlyUsed: false,
                      mainMobileButton: false
                  },
                    { caption: 'Delete', icon: deleteIcon, minRecordsRequired: 1, frequentlyUsed: false, mainMobileButton: false },
                ]}
                  tableName="Couples"
                  displayFields={[
                    ...showAllColumnsDesktop,
                    ...(this.state.scoGivenToExist ? [SCOGiven] : []),
                    ...(this.state.scoReceivedFromExist ? [SCOReceived] : []),
                  ]} />
                  <Modal isOpen={this.state.sendReportModal} onClose={() => this.closeModal()}>
                    <h2>Send Couples Report</h2>
                    <div style={{ display: this.state.impersonator==="true" ? 'visible' : 'none' }}>
                      <div className="input-wrapper-2">
                        <input className="input" type="email" name="coachEmailAddress" id="coachEmailAddress" onChange={this.handleChange} value={this.state.coachEmailAddress} autoFocus />
                        <label className="edit" htmlFor="coachEmailAddress">Coach Email Address</label>
                      </div>
                    </div>
                    <Button disabled={this.state.disableGmail} variant="contained" color="primary" type="submit" onClick={() => this.checkForSuppliedReports(false)}>
                      <span style={{ display: this.state.disableGmail ? "none" : "block" }}><span style={{textTransform:"none"}}>Send from my email address</span></span>
                      <span style={{ display: this.state.disableGmail ? "block" : "none", fontSize: "1.2vh", textTransform: "none", color:"black" }}>Can't send from your email address because<br></br> more than one assessment has been selected.</span>
                    </Button>
                    <br></br>
                    <Button variant="contained" color="primary" type="submit" onClick={() => this.checkForSuppliedReports(true)}><span style={{textTransform:"none"}}>Send from aim@aephoria.co.za</span></Button>
                  </Modal>

                  <Modal isOpen={this.state.previewModal} onClose={() => this.closeModal()}>
                    <h2>Preview</h2>
                    <p>Sending your couples report to {this.state.listOfReportsReady.length} {this.state.selected > 1 ? "clients" : "client"}</p>
                    <p style={{ color: "red" }}>{this.state.previewExplanation.split('. ').map((line,i) => <span key={i}>{line}.<br></br></span>)}</p>
                    <div id="previewTextArea" contentEditable={false} className="editable"></div>
                    <br/><br/>
                    <Button variant="contained" color="primary" type="submit" onClick={() => this.sendReport(true)}>Proceed with Send</Button>
                    <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel Send</Button>
                  </Modal>
                  <div className="pronounModal">
                    <Modal isOpen={this.state.editPronounsModal} onClose={() => this.closeModal()}>
                      <h2>Edit Pronouns</h2>
                      <div className="styled-select">
                        <select
                          id="editPerson1Pronouns"
                          name="editPerson1Pronouns"
                          value={this.state.editPerson1Pronouns}
                          onChange={this.handleChange}
                        >
                          {pronounOptions}
                        </select>
                        <label>Pronouns for {this.state.editPerson1Name}</label>
                      </div>
                      <div className="styled-select">
                        <select
                          id="editPerson2Pronouns"
                          name="editPerson2Pronouns"
                          value={this.state.editPerson2Pronouns}
                          onChange={this.handleChange}
                        >
                          {pronounOptions}
                        </select>
                        <label>Pronouns for {this.state.editPerson2Name}</label>
                      </div>
                      <br></br>
                      <Button variant="contained" color="primary" type="submit" onClick={() => this.saveEditedPronouns()}>Save</Button>
                    </Modal>
                  </div>

                <Modal isOpen={this.state.confirmationModal} onClose={() => this.closeModal()}>
                  <h3>{this.state.confirmationHeading}</h3>
                  {this.state.confirmationModalText}
                  <br /><br />
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.state.confirmationFunction(true)}>Ok</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                {/* ========================= Assign SCO Modal =========================== */}
                <Modal isOpen={this.state.assignSCOModalOpen} onClose={() => this.closeModal()}>
                  <h2>Assign Secondary Ownership</h2>
                  <span>Enter Secondary Coach Email Address:</span>
                  <br></br>
                  <div className="input-wrapper-2">
                    <input className="input" type="email" name="secondaryCoachEmailAddress" id="secondaryCoachEmailAddress" maxLength="45" onChange={this.handleChange} value={this.state.secondaryCoachEmailAddress} style={{ "margin": "10px 0px", "padding": "8px 16px", "minWidth": "100%" }} />
                    <label className="edit">Email</label>
                  </div>
                  <p style={{ display: this.state.showInvalidEmailAddressText ? "block" : "none", color: "red" }}>Please enter a valid email address.</p>
                  <p>You will be assigning secondary coach ownership to this coach, for the {this.state.selectedCoupleUUIDs.length} selected pair(s).</p>
                  <p>Please take care when assigning SCO as you are sharing sensitive data that requires data protection to another party. If you do not yet have an agreement with the coach in question around use of sensitive personal information, please put this in place prior to assigning SCO rights.</p>
                  <p>The secondary coach will be able to view and send the pair report. You can revoke SCO at any time - click the trashcan icon shown after a coach name in the "Given To" column on the Pairs table.</p>
                  <Button variant="contained" color="primary" type="submit" disabled={this.state.invalidEmailAddress ? true : false} onClick={() => this.assignCoupleSCO()}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                <Modal isOpen={this.state.revokeSCOModal} onClose={() => this.closeModal()}>
                  <h3>{this.state.revokeSCOModalTitle}</h3>
                  <p>{this.state.revokeMessage}</p>
                  <Button variant="contained" color="primary" type="submit" onClick={this.state.revokeModalSubmitFunction}>Revoke</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                  <Toast
                    level={this.state.level}
                    message={this.state.message}
                    visible={this.state.showToast}
                  />

                  <AlertModal
                    message={this.state.alertMessage}
                    modalTitle={this.state.alertModalTitle}
                    isOpen={this.state.openAlertModal}
                    showClose={() => this.closeModal()}
                  />
            <LoadingBackdrop open={this.state.openBackdrop} />
          </main>
        );
    }
}

export default withRouter(withStyles(styles)(Couples))
